import { render, staticRenderFns } from "./DynamicDetails.vue?vue&type=template&id=3b3ffb5a"
import script from "./DynamicDetails.vue?vue&type=script&lang=js"
export * from "./DynamicDetails.vue?vue&type=script&lang=js"
import style0 from "./DynamicDetails.vue?vue&type=style&index=0&id=3b3ffb5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports